import React, { useEffect, useState } from 'react';
import { Modal, Box, Button, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import "../FavoritesListSearch/FavoriteListSearch.css";
import { APIUrlThree, APIUrlToken, GetUserId } from '../../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddToFavoritePeopleModal = ({ open, handleClose, selectedOuterRows, setOpen, message, handlePassSubmit, setSelectedOuterRows }) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };

    const userId = GetUserId()
    const [loading, setLoading] = useState()
    const [selectedList, setSelectedList] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    const [favoriteModal, setFavoriteModal] = useState(false);
    const [addFavouriteModal, setAddFavouriteModal] = useState(false);
    const [listName, setListName] = useState("");

    const [selectedOption, setSelectedOption] = useState(false);

    const handleOpenFavoriteModal = () => {
        if (!selectedValue) {
            toast.error("Please Select Existing Name");
            return;
        }
        setFavoriteModal(true);
        setOpen(false)

    }
    const handleCloseFavoriteModal = () => setFavoriteModal(false);

    const handleOpenAddFavouriteModal = () => {
        setAddFavouriteModal(true);
        setOpen(false)
        setSelectedValue("")

    }
    const handleCloseAddFavouriteModal = () => setAddFavouriteModal(false);





    const getFavListPeople = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/get_favourite_list_people?user_id=${userId}`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    if (Array.isArray(e.data.data)) {
                        setSelectedList(e.data.data);
                    } else if (Array.isArray(e.data?.lists)) {
                        setSelectedList(e.data.lists);
                    } else {
                        console.error("Unexpected API response format:", e.data);
                        setSelectedList([]);
                    }
                    toast.success(e?.data?.message);
                }
            })
            .catch((err) => {
                console.error("Error fetching favorite lists", err);
                setLoading(false);
            });
    };

    useEffect(() => {
        getFavListPeople();
    }, [open])


    const handleFavAddRecords = (id) => {
        setLoading(true);
        const personIds = selectedOuterRows.map(row => row.person_id);

        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            data: personIds,
            url: `${APIUrlThree()}/favorites/people/list/add-record?user_id=${userId}&list_id=${selectedValue ? selectedValue : id}`,
        };

        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    setSelectedList(e.data);
                    setFavoriteModal(false);
                    handlePassSubmit()
                    setSelectedOuterRows([])
                    toast.success(e.data?.message);
                    // if (e?.data?.already_existing.length) {
                    //     toast.error(e.data.already_existing[0].message);
                    // } else {
                    //     toast.success(e.data?.message);
                    // }
                }
            })
            .catch((err) => {
                console.error('Error enriching prospect', err);
                setLoading(false);
            });
    };


    const saveOrgFavList = () => {
        if (!listName.trim()) {
            toast.error("Please Type List Name");
            return;
        }
        setLoading(true);
        const data = {
            user_id: userId,
            name: listName,
            isPrivate: true,
            type: "people",

        };
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/save_favourite_list_people`,
            data: data,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    handleFavAddRecords(e.data.data.id)
                    toast.success(e?.data?.message)
                    setListName("");
                    setAddFavouriteModal(false)
                    setSelectedOuterRows([])
                    handlePassSubmit()
                }

            })
            .catch((err) => {
                console.error('Error enriching prospect', err);
                setLoading(false);
            });
    };

    return (
        <>
            {/* {loading ? <Loader/> : null} */}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            Add To Favorites List
                            <ClearIcon onClick={() => { setOpen(false) }} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="input-list-fav-create">
                                <label>Existing List Name</label>

                                <Select
                                    className="input-list-fav-create-select"
                                    value={selectedValue}
                                    onChange={(e) => setSelectedValue(e.target.value)}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select a list</MenuItem>
                                    {Array.isArray(selectedList) ? selectedList.map((item) => (
                                        <MenuItem key={item?.id} value={item?.id}>
                                            {item?.name}
                                        </MenuItem>
                                    )) : (
                                        <MenuItem key={selectedList?.id} value={selectedList?.id}>
                                            {selectedList?.name}
                                        </MenuItem>
                                    )}
                                </Select>


                            </div>
                            <div className='create-new-list-inner-modal' onClick={handleOpenAddFavouriteModal}>
                                <p> <AddIcon /> Create New List </p>
                            </div>

                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={() => { setOpen(false) }} >
                                        Cancel
                                    </Button>
                                    <Button className="de_next"
                                        // onClick={handleFavAddRecords}
                                        onClick={handleOpenFavoriteModal}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            <Modal open={favoriteModal}>
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            {message}
                            <ClearIcon onClick={handleCloseFavoriteModal} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={handleCloseFavoriteModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="de_next"
                                        // disabled={!selectedOption}
                                        onClick={handleFavAddRecords}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            {/* Add to Favorites List Modal */}
            <Modal open={addFavouriteModal}>
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            Add to Favorites List
                            <ClearIcon onClick={handleCloseAddFavouriteModal} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="input-list-fav-create">
                                <label htmlFor="">New List Name</label>
                                <input type="text" onChange={(e) => setListName(e.target.value)} value={listName} />
                            </div>
                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={handleCloseAddFavouriteModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="de_next"
                                        onClick={saveOrgFavList}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
        </>
    );
};

export default AddToFavoritePeopleModal